import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { WarningCircleIcon } from '@icons';

import { useQueryGetMe } from '@hooks/api/user/use-query-me.ts';

import * as Styled from './match-history.styled';

const MatchHistory = () => {
	const { data: user } = useQueryGetMe();

	const { t } = useTranslation('profile');

	if (user?.steam_private_match_data) {
		return null;
	}

	return (
		<Styled.Wrapper>
			<Styled.Title>{t('match_history')}</Styled.Title>
			<Styled.Main>
				<Styled.Text>
					<WarningCircleIcon />
					{t('match_history_closed')}
				</Styled.Text>
				<Styled.Info>
					<Styled.InfoItem>{t('go_to_settings')}</Styled.InfoItem>
					<Styled.InfoItem>{t('in_chapter')}</Styled.InfoItem>
				</Styled.Info>
			</Styled.Main>
		</Styled.Wrapper>
	);
};

export default MatchHistory;
